/*
	Sets a class on elements when they scroll into viewport.
	Rewritten to use IntersectionObserver API
	https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
*/
window.Inview = function()
{
	var self = this;

	this.observer = new IntersectionObserver(

		// callback
		this.intersect.bind(self),

		// options
		{
			root:null, // = viewport
			rootMargin: '0px',
			threshold: 0.25 // 25% of the element in view
		}
	);

	setTimeout(function(){
		self.init();
	},100)

	// IE fallback
	var ua = window.navigator.userAgent;
	if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0) {
		$('.inview').addClass('inview-initial inview-any');
	}
}

Inview.prototype = {

	init()
	{
		var self = this;
		document.getElementsByClassName('inview').forEach((el) => {
			self.observer.observe(el);
		});
	},

	intersect(entries)
	{
		var self = this;

		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('inview-initial','inview-any');
				self.observer.unobserve(entry.target);
			}
		});
	}
};
